export type ShiftType = "dayshift" | "nightshift";

export interface ShiftInfo {
  date: string;
  shift: ShiftType;
}

export function getShiftInfo(inputDate: Date): ShiftInfo {
  const adjustedDate = new Date(inputDate.getTime());
  const hours = adjustedDate.getHours();

  if (hours >= 21 || hours < 8) {
    adjustedDate.setDate(adjustedDate.getDate() - 1);
    return {
      date: adjustedDate.toISOString().split('T')[0],
      shift: "nightshift",
    };
  } else {
    return {
      date: adjustedDate.toISOString().split('T')[0],
      shift: "dayshift",
    };
  }
}


export const formatDateTime = (date: Date) => {
  const year = date.getFullYear();
  const month = ('0' + (date.getMonth()+1)).slice(-2) ;
  const day = ('0' + date.getDate()).slice(-2);
  const hours = ('0' + (date.getHours())).slice(-2);
  const minutes = ('0' + (date.getMinutes())).slice(-2);
  const seconds = ('0' + (date.getSeconds())).slice(-2);

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
};